export default function getNumberOfDaysOldInvoice (invDate) {
  let date = new Date(invDate)
  let ageDifMs = Date.now() - date.getTime();
  let difference = ageDifMs / (1000*3600 *24)
  return difference
}